import React from 'react';
import { motion } from 'framer-motion';
import { Brain, DollarSign, Zap } from 'lucide-react';
const benefits = [{
  icon: Brain,
  title: 'VAS A ENTENDER TU MOTOR',
  description: 'Sabé exactamente qué pasa con tu moto y cómo solucionarlo'
}, {
  icon: DollarSign,
  title: 'VAS A DEJAR DE GASTAR PLATA',
  description: 'Hacé vos mismo lo que antes pagabas caro en el taller'
}, {
  icon: Zap,
  title: 'VAS A TENER MÁS POTENCIA',
  description: 'Optimizá el rendimiento al máximo con ajustes precisos'
}];
export function BenefitsSection() {
  return <section className="w-full bg-gradient-to-b from-gray-900 to-motor-black py-14 px-4 sm:px-6 lg:px-8 metal-texture" data-id="element-12">
      <div className="max-w-6xl mx-auto" data-id="element-13">
        <div className="space-y-8" data-id="element-14">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -40 : 40
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.15
        }} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-6 lg:gap-12`} data-id="element-15">
              <div className="flex-shrink-0 flex justify-center" data-id="element-16">
                <div className="w-24 h-24 bg-motor-red/10 rounded-full flex items-center justify-center border-4 border-motor-red shadow-red-glow-lg" data-id="element-17">
                  <benefit.icon className="w-12 h-12 text-motor-red" data-id="element-18" />
                </div>
              </div>

              <div className="flex-1 text-center lg:text-left" data-id="element-19">
                <h3 className="font-bebas text-3xl sm:text-4xl lg:text-5xl text-white uppercase mb-2 leading-tight" data-id="element-20">
                  {benefit.title}
                </h3>
                <p className="text-lg text-gray-300 font-montserrat font-medium" data-id="element-21">
                  {benefit.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}